import { useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { CompanyProvider } from './context/CompanyContext';
import Header from './components/Header';
import LegalGate from './components/LegalGate';
import LegalPage from './pages/LegalPage';
import Login from './pages/Login';
import Signup from './pages/Signup';
import VerifyOtp from './pages/VerifyOtp';
import ForgotPassword from './pages/ForgotPassword';
import Companies from './pages/Companies';
import Dashboard from './pages/Dashboard';
import ConsolidatedDashboard from './pages/ConsolidatedDashboard';
import Calendar from './pages/Calendar';
import GstReturns from './pages/GstReturns';
import TdsTcs from './pages/TdsTcs';
import RocMca from './pages/RocMca';
import AiNotice from './pages/AiNotice';
import Financials from './pages/Financials';
import Documents from './pages/Documents';
import Settings from './pages/Settings';
import ComplianceSetup from './pages/ComplianceSetup';
import DataEntry from './pages/DataEntry';
import Setup from './pages/Setup';
import RootRedirect from './pages/RootRedirect';
import ClientMaster from './pages/ClientMaster';
import DscRegister from './pages/DscRegister';
import ItrFiling from './pages/ItrFiling';
import AuditStatus from './pages/AuditStatus';
import NotesReminders from './pages/NotesReminders';
import './App.css';

function CompaniesPage() {
  return (
    <>
      <Header />
      <Companies />
    </>
  );
}

function AuthGate({ children }) {
  const { isAuthenticated } = useAuth();
  const [view, setView] = useState('login'); // 'login' | 'signup' | 'verify-otp' | 'forgot-password'
  const [pendingEmail, setPendingEmail] = useState('');

  if (!isAuthenticated) {
    if (view === 'signup') {
      return (
        <Signup
          onSignedUp={(email) => {
            setPendingEmail(email);
            setView('verify-otp');
          }}
          onBackToLogin={() => setView('login')}
        />
      );
    }
    if (view === 'verify-otp') {
      return <VerifyOtp email={pendingEmail} onBackToLogin={() => setView('login')} />;
    }
    if (view === 'forgot-password') {
      return <ForgotPassword onBackToLogin={() => setView('login')} />;
    }
    return (
      <Login
        onGoToSignup={() => setView('signup')}
        onGoToForgotPassword={() => setView('forgot-password')}
      />
    );
  }
  return children;
}

function AppShell() {
  const { logout } = useAuth();
  return (
    <AuthGate>
      <CompanyProvider>
        <LegalGate onSignOut={logout}>
          <Routes>
              <Route path="/" element={<RootRedirect />} />
              <Route path="/setup" element={<Setup />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/dashboard/consolidated" element={<ConsolidatedDashboard />} />
              <Route path="/calendar" element={<Calendar />} />
              <Route path="/gst" element={<GstReturns />} />
              <Route path="/tds" element={<TdsTcs />} />
              <Route path="/roc" element={<RocMca />} />
              <Route path="/ai-notice" element={<AiNotice />} />
              <Route path="/financials" element={<Financials />} />
              <Route path="/legal-docs" element={<Documents />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/compliance-setup" element={<ComplianceSetup />} />
              <Route path="/data-entry" element={<DataEntry />} />
              <Route path="/clients" element={<ClientMaster />} />
              <Route path="/dsc-register" element={<DscRegister />} />
              <Route path="/itr-filing" element={<ItrFiling />} />
              <Route path="/audit-status" element={<AuditStatus />} />
              <Route path="/notes" element={<NotesReminders />} />
            <Route path="/companies" element={<CompaniesPage />} />
          </Routes>
        </LegalGate>
      </CompanyProvider>
    </AuthGate>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Outside AuthGate deliberately: these have to be readable before
              signing up, since that is when someone is asked to accept them,
              and they are linked from the public signup form and the footer. */}
          <Route path="/terms" element={<LegalPage />} />
          <Route path="/privacy" element={<LegalPage />} />
          <Route path="/disclaimer" element={<LegalPage />} />
          <Route path="*" element={<AppShell />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
